import { FC, useEffect, useState } from 'react';
import { SearchUnallocatedByWasteItemConditions } from '../../../../../../../types/carAllocation';
import styles from './styles.module.css';
import Input from '../../../../../../../components/common/Input';
import Button from '../../../../../../../components/common/Button';
import {
  keyList,
  useKeyAction,
} from '../../../../../../../services/useKeyAction';

type Props = {
  initConditions: SearchUnallocatedByWasteItemConditions;
  conditions: SearchUnallocatedByWasteItemConditions;
  updateConditions: (condition: SearchUnallocatedByWasteItemConditions) => void;
};
const Conditions: FC<Props> = ({
  initConditions,
  conditions,
  updateConditions,
}) => {
  const [currentConditions, setCurrentConditions] = useState(conditions);
  useEffect(() => {
    setCurrentConditions(conditions);
  }, [conditions]);
  const clearConditions = () => {
    setCurrentConditions({
      // limit や page といったページング関連の状態を残すために currentConditions をベースとして使う
      ...currentConditions,
      ...initConditions,
    });
    updateConditions({ ...currentConditions, ...initConditions });
  };
  const onSearch = () => updateConditions({ ...currentConditions, page: 1 });
  const onConditionEnter = useKeyAction(keyList.ENTER, onSearch);

  return (
    <div className={styles.container} onKeyDown={onConditionEnter}>
      <div className={styles.contractNo}>
        <Input
          value={currentConditions.contractNo}
          onChange={(e) =>
            setCurrentConditions({
              ...currentConditions,
              contractNo: e.target.value,
            })
          }
          variants={['fit']}
          placeholder="契約No"
        />
      </div>
      <div className={styles.companyName}>
        <Input
          value={currentConditions.companyName}
          onChange={(e) =>
            setCurrentConditions({
              ...currentConditions,
              companyName: e.target.value,
            })
          }
          variants={['fit']}
          placeholder="排出事業者・委託先・排出事業場"
        />
      </div>
      <div className={styles.button}>
        <Button
          onClick={clearConditions}
          variants={['fit', 'contain', 'cancel']}
        >
          クリア
        </Button>
      </div>
      <div className={styles.button}>
        <Button
          onClick={onSearch}
          variants={['fit', 'contain', 'search', 'secondary']}
        >
          検索
        </Button>
      </div>
    </div>
  );
};

export default Conditions;
